import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import SystemContext from "@context/SystemContext";

const CodeCapture = () => {
  const location = useLocation();
  const { setLoginInfo } = useContext(SystemContext);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const codeFromUrl = urlParams.get("code");

    if (codeFromUrl && setLoginInfo) {
      setLoginInfo((prevState) => ({ ...prevState, code: codeFromUrl }));
    }
  }, [location.search, setLoginInfo]);

  return null;
};

export default CodeCapture;